import get from 'lodash/get';
import omit from 'lodash/omit';
import { user } from 'stardog';
import { getStardogConnection, isCypress } from 'vet-bones/utils';
import { isPortal } from 'vet-bones/utils/portal';

import { Connection } from 'src/store/connections/types';

export const upgradeConnection = async (
  connection: Connection
): Promise<Connection> => {
  if (isPortal() && !isCypress()) {
    return connection;
  }

  let upgradeResponse;

  try {
    upgradeResponse = await user.token(getStardogConnection(connection));
  } catch (_error) {
    // We assume if there was an error the endpoint does not support
    // tokens or the token is invalid in some unexpected way so remove it.
    return omit(connection, 'token');
  }

  if (!upgradeResponse.ok) {
    // Clear any token that is stored on the connection so we can prompt the
    // user to re-enter their password.
    return omit(connection, 'token');
  }

  const token = get(upgradeResponse, ['body', 'token'], undefined);
  const endpoint = get(
    upgradeResponse,
    ['body', 'endpoint'],
    connection.endpoint
  );
  const username = get(
    upgradeResponse,
    ['body', 'username'],
    connection.username
  );

  return {
    ...connection,
    token,
    username,
    endpoint,
  };
};
